/**
 * Single source of truth for the legal identity shown across SOXIE365 policies.
 */
export const LEGAL = {
  brand: "SOXIE365",
  /** Registered legal entity name. */
  entity: "SSCS SERVICES LTD",
  /** Registered/company number. */
  registrationNumber: "HE 393290",
  /** VAT identification number (required for EU B2C distance selling). */
  vatNumber: "1039329OU",

  /** Full registered address. */
  address: {
    line1: "Amathountos 59, Kypriopoulos Court B",
    city: "Agios Tychonas, Limassol",
    postalCode: "4532",
    country: "Cyprus",
  },
  tradingName: "SOXIE365",
  supportEmail: "info@soxie365.com",
  privacyEmail: "info@soxie365.com",

  site: "https://www.soxie365.com",
  domain: "www.soxie365.com",
  /** Governing law for the terms of sale. */
  governingLaw: "Cyprus",
  lastUpdated: "21 August 2026",
} as const;

export const LEGAL_ADDRESS_LINE = [
  LEGAL.address.line1,
  LEGAL.address.postalCode,
  LEGAL.address.city,
  LEGAL.address.country,
].join(", ");

export const LEGAL_ROUTES = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/cookies", label: "Cookie Policy" },
  { to: "/terms", label: "Terms of Sale" },
  { to: "/returns", label: "Returns & Refunds" },
  { to: "/legal-notice", label: "Legal Notice" },
] as const;
